import React, { useState } from "react";
import { Alert, Button, Card, Form } from "react-bootstrap";
import api from "../../../axiosConfig";

export default function InterventionsSummary({ id }) {
  const now = new Date();
  const month = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  const [from, setFrom] = useState(`${month}-01`);
  const [to, setTo] = useState(`${month}-${String(now.getDate()).padStart(2, "0")}`);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  if (!id) return null;
  const load = async () => {
    setResult(null); setError("");
    if (!from || !to || from > to) { setError("Alegeți o perioadă validă."); return; }
    setLoading(true);
    try { setResult((await api.get(`/contor/echipamente/${id}/interventii`, { params: { de_la: from, pana_la: to } })).data); }
    catch (e) { setError(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Nu s-a putut calcula numărul intervențiilor."); }
    finally { setLoading(false); }
  };
  return <Card className="mb-3">
    <Card.Header>Intervenții în perioadă</Card.Header>
    <Card.Body>
      <p>Se numără toate sesizările, inclusiv citirile CONTOR, indiferent dacă sunt facturabile.</p>
      <div className="d-flex flex-wrap align-items-end gap-2">
        <Form.Group controlId="interventions-from"><Form.Label>De la</Form.Label><Form.Control type="date" value={from} disabled={loading} onChange={e => { setFrom(e.target.value); setResult(null); }} /></Form.Group>
        <Form.Group controlId="interventions-to"><Form.Label>Până la</Form.Label><Form.Control type="date" value={to} disabled={loading} onChange={e => { setTo(e.target.value); setResult(null); }} /></Form.Group>
        <Button type="button" onClick={load} disabled={loading}>{loading ? "Se calculează…" : "Numără sesizările"}</Button>
      </div>
      {error && <Alert variant="danger" className="mt-2">{error}</Alert>}
      {result && <Alert variant="info" className="mt-2">Total: <strong>{result.total}</strong> sesizări, în perioada {result.de_la} – {result.pana_la}.</Alert>}
    </Card.Body>
  </Card>;
}
